import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { convertToFormattedDate } from '../../../shared/utils/dateUtils';


@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddComponent implements OnInit {
  addForm: FormGroup;

  minDate: any;
  maxDate: any;

  loading = false;
  constructor(public dialogRef: MatDialogRef<AddComponent>, private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.minDate = new Date();
    this.maxDate = new Date(new Date().getFullYear()+1, 11, 31);
    this.addForm = this.formBuilder.group({
      dateVal: ['', Validators.required]
    });
  }

  addCourtDate() {
    let addFormRequest = this.addForm.value;
    let tempDate = convertToFormattedDate(addFormRequest.dateVal);
    this.dialogRef.close({val: true, date: tempDate});
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/court-dates/add/add.component.ts